import notificationSound from '../audio/parked_sale_notification.wav'

export interface IUberEatsChime {
  /** Resolves false when the browser blocks playback (autoplay policy); never rejects. */
  play(): Promise<boolean>
  /** Unlocks playback from a user gesture by playing the sound muted. Never rejects. */
  prime(): Promise<boolean>
}

const createDefaultAudio = () => new Audio(notificationSound)

export const createUberEatsChime = (
  createAudio: () => HTMLAudioElement = createDefaultAudio,
): IUberEatsChime => {
  let audio: HTMLAudioElement | undefined

  const getAudio = () => {
    if (!audio) audio = createAudio()
    return audio
  }

  const play = async () => {
    try {
      const element = getAudio()
      element.currentTime = 0
      await element.play()
      return true
    } catch {
      return false
    }
  }

  const prime = async () => {
    try {
      const element = getAudio()
      element.muted = true
      await element.play()
      element.pause()
      element.currentTime = 0
      return true
    } catch {
      return false
    } finally {
      if (audio) audio.muted = false
    }
  }

  return { play, prime }
}
